import "./ui.css"

/**
 * Spinner - accessible loading indicator.
 *
 * Usage:
 *  <Spinner />                         inline, label read by screen readers only
 *  <Spinner size="lg" block showLabel label="Loading ports…" />   centred block for a card/section
 *
 * Props:
 *  - size: "sm" | "md" | "lg" (default "md")
 *  - label: announced text (default "Loading…")
 *  - showLabel: also show the label visually
 *  - block: centred, full-width block with a minimum height (replaces ad-hoc loader wrappers)
 */
export default function Spinner({ size = "md", label = "Loading…", showLabel = false, block = false, className = "" }) {
  return (
    <span
      className={`vy-spinner-wrap ${block ? "vy-spinner-wrap--block" : ""} ${className}`.replace(/\s+/g, " ").trim()}
      role="status"
    >
      <span className={`vy-spinner vy-spinner--${size}`} aria-hidden="true" />
      <span className={showLabel ? "vy-spinner__label" : "vy-visually-hidden"}>{label}</span>
    </span>
  )
}
